module.exports = __webpack_public_path__ + "static/img/f2.fda8420.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui3/f2.png
// module id = KHtB
// module chunks = 1